
const digest = 'b00059fcd96185490e9cde884e2a1401602d2452b5941ff9f9baa08c12165d15';
const classes = {"wrapper":"_wrapper_glm9m_1","columnsWrapper":"_columnsWrapper_glm9m_8"};
const css = `._wrapper_glm9m_1 {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding: 24px;
}

._columnsWrapper_glm9m_8 {
  display: flex;
  flex-direction: row;
  justify-content: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  